export const LOGIN = "/login";
export const DASHBOARD = "/";

//
export const CUSTOMERS = "/customers";
export const CUSTOMER_DASHBOARD = "/customers/:id";

//
export const CUSTOMER_VOUCHERS = "/customers/:id/vouchers";
export const CUSTOMER_PAPERS = "/customers/:id/papers";
export const CUSTOMER_ADDITIONAL_PAPERS = "/customers/:id/papers/additional";
export const CUSTOMER_HOLIDAYS = "/customers/:id/holidays";
export const CUSTOMER_TRANSACTION = "/customers/:id/transactions";

//
export const VOUCHERS = "/management/vouchers";
export const PAYMENTS = "/management/payments";
export const ASSIGNED_PAPERS = '/management/assigned-papers';

//
export const CUSTOMERS_QUERY = "/reports/customers";
export const PAPER_QUERY = "/reports/papers";

//
export const USERS = "/access/users";
export const ROLES = "/access/roles";

//
export const BRANCHES = "/master-data/branches";
export const BRANCHVIEW = "/master-data/branches/:id";
export const PAPERS = "/master-data/papers";
export const ROUNDS = "/master-data/rounds";
export const DELIVERY_FEE = "/master-data/delivery-charges";
